import React from "react";
import style from "./footer.module.css";
import "./footer.css";
import { Link } from "react-router-dom";

class Footer extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    return (
      <>
        <footer className="allscreens">
          <p className="mb-0">
            Copyright © {new Date().getFullYear()} Fonolive. All rights
            reserved. Contact: pr@fonolive.com
          </p>
          <div>
            <Link to="/return-policy">Returns</Link>{" "}
            <Link to="/privacy">Privacy</Link> <Link to="/terms">Terms</Link>{" "}
            <Link to="/about">About</Link> <Link to="/tips">Tips</Link>{" "}
            <Link to="/fees">Fees</Link> <Link to="/contact">Contact</Link>{" "}
            <a
              style={{ marginLeft: "5px" }}
              href="https://fonolive.com/search/jobs"
            >
              Jobs
            </a>
            <a
              style={{ marginLeft: "5px" }}
              href="https://fonolive.com/search/articles"
            >
              Articles
            </a>
            <a
              style={{ marginLeft: "5px" }}
              href="https://fonolive.com/search/business"
            >
              Business
            </a>
            <a style={{ marginLeft: "5px" }} href="https://fonolive.com/slangs">
              Slangs
            </a>
            {/*<a style={{ marginLeft: "5px" }} href="https://fonolive.com/names">
              Names
            </a>*/}
          </div>
        </footer>
      </>
    );
  }
}

export default Footer;
